module.exports = __webpack_public_path__ + "img/weixin_tip.f2143b46.png";